import React, {Component} from "react"

import InspirationsQuery, {InspirationsData} from "@irati/recognition/apollo/query/Inspirations"
import {Hr} from "@irati/ui/src/Layout"
import {H3} from "@irati/ui/src/Typography/Heading"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"

import {InspirationModalTiles} from "../../Inspiration"

interface Props {
  onSelect(): void
}

class Inspire extends Component<Props> {
  render() {
    const tenantId = authentication.userTenant().uuid
    const {onSelect} = this.props
    const variables = {
      tenantId
    }

    return (
      <div>
        <H3><FormattedMessage id="recognition.popup.createPoll.inspire.header" /></H3>
        <Hr />
        <InspirationsQuery variables={variables}>
          {({data: {inspirations: {results = []}}}: InspirationsData) => (
            <InspirationModalTiles inspirations={results} onClick={onSelect} />
          )}
        </InspirationsQuery>
      </div>
    )
  }
}

export default Inspire
